import './index.css';
import { mountSurfaceApp } from './app/mountSurfaceApp';

mountSurfaceApp();
